export default "__VITE_ASSET__UUxZXUhp__"